<script>
	import PageSection from "../../components/PageSection.svelte";
	import IFrame from "../../components/IFrame.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Check for the back button
	if ($pageNumber == 2) {
		alert("The form has already been submitted.");
		window.location.href = "/";
	} else {
		pageNumber.update((p) => pageIndex);
	}

	let url = `https://au.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=48efb73e-4f60-475f-9074-f65c779c15f0&env=au&acct=4435ed7e-65de-4d1d-a907-b11f469ab88f&v=2&Client_UserName=${$model.FirstName} ${$model.Surname}&Client_Email=${$model.EmailAddress}&ClientAddress=${$model.Address}`;
</script>

{#if $pageNumber == 1}
	<PageSection>
		<h2>Litigation Funding Agreement and Conditional Costs Agreement</h2>

		<p>
			To obtain funding for Shine Lawyers to deliver all legal and professional work required to run the class
			action and to verify, conduct and quantify your claim, we request you sign the Litigation Funding and
			Conditional Costs Agreements. These can be accessed via the unique links below; please note that your
			signature is not required to sign these online agreements.
		</p>
		<p>You can agree to these agreements in one of two ways:</p>
		<ul>
			<li>Tick the boxes below; OR</li>
			<li>
				If you wish, you are welcome to download hardcopy versions of these agreements which can be downloaded
				below. To return, please print, sign and then post or email the agreements to our offices on <strong
					>PO Box 589, Darlinghurst NSW 1300</strong
				>.
			</li>
		</ul>

		<div class="top_cont">
			<div class="form_cont">
				<IFrame height="800px" title="Funding Agreement" classname="signframe" {url}></IFrame>
			</div>
		</div>

		<p>
			If you are having trouble viewing the funding and costs agreements or <b
				>would like to download a copy, see below</b
			>:
		</p>

		<ul>
			<li>
				Funding Agreement - <a target="_blank" href={projectSettings.lfaDocumentUrl} title="Funding agreement"
					>Download here</a
				>
			</li>
			<li>
				Costs Agreement – <a
					target="_blank"
					href={projectSettings.costAgreementDocumentUrl}
					title="Costs agreement">Download here</a
				>
			</li>
		</ul>

		<h2>Agreement Declaration</h2>

		<p>By ticking the box below you confirm that:</p>
		<ul>
			<li>
				I confirm that I am the claimant described above, or am duly authorised to act on the claimant's behalf
				I understand that I am entering into a legally binding agreement (the Funding Agreement and Costs
				Agreement)
			</li>
			<li>
				I confirm that I have been informed of my right to obtain, and have obtained, all independent legal,
				financial and other professional advice before entering into the Agreements that I consider necessary
			</li>
			<li>
				I expressly consent to this method of acceptance in accordance with s9(1) of the Electronic Transactions
				(New South Wales) Act 2000 and accept the terms of the agreement by electronic acceptance
			</li>
			<li>
				I consent to Shine Lawyers and Balance Legal Capital I UK Ltd collecting, storing, using and disclosing
				personal information provided by me in accordance with and subject to the Agreements and the Privacy
				Policy which is available on the Shine website.
			</li>
			<li>
				I understand I have a 5 day cooling off period from the date I sign this registration form, which
				cooling off period enables me to seek external legal advice, raise any questions, negotiate terms or
				withdraw from the agreements
			</li>
		</ul>

		<form novalidate autocomplete="off">
			<div class="form-row">
				<div class="col-md-12">
					<Checkbox
						bind:checked={$model.LFAConfirmed}
						label="Agree to Litigation Funding Agreement"
						required="true"
						id="lfa"
					></Checkbox>
				</div>
			</div>

			<div class="form-row">
				<div class="col-md-12">
					<Checkbox
						bind:checked={$model.CostAgreementConfirmed}
						label="Agree to Conditional Cost Agreement"
						required="true"
						id="ca"
					></Checkbox>
				</div>
			</div>

			<div class="form-row">
				<div class="col-md-12 last">
					<NavigationButtons {persistUrl} {previousPage} {nextPage} nextPageLabel="Submit"
					></NavigationButtons>
				</div>
			</div>
		</form>
	</PageSection>
{/if}

<style>
	:global(.signframe) {
		height: 700px;
		width: 1024px;
		border: none;
	}
	:global(.signframe) {
		background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100% 100%"><text fill="%23FF0000" x="50%" y="50%" font-family="\'Lucida Grande\', sans-serif" font-size="24" text-anchor="middle">Loading...</text></svg>')
			0px 0px no-repeat;
	}

	.form_cont {
		border: 1px solid #cfc;
		padding: 20px;
		background-color: #cd9;
	}

	.top_cont {
		margin-left: auto;
		margin-right: auto;
	}
</style>
